// extracted by mini-css-extract-plugin
module.exports = {"EllipsisMenu":"EllipsisMenu_EllipsisMenu__1YuRN","Options":"EllipsisMenu_Options__19T9U","Show":"EllipsisMenu_Show__3nw1H"};